import { useState } from "react";
import { Link } from "react-router-dom";
import { Plus, Minus, ArrowRight } from "lucide-react";
import Reveal from "../components/Reveal";
import PageHeader from "../components/PageHeader";
import { FAQS } from "../data/products";

export default function FAQ() {
  const [open, setOpen] = useState(0);
  return (
    <>
      <PageHeader
        eyebrow="Frequently Asked"
        title="The questions every serious buyer asks."
        italicWord="serious"
        subtitle="Clear answers to the questions we receive most from international importers, distributors and private label brands. If yours isn't here — write to us and we will answer directly."
      />

      <section className="py-24 md:py-32 bg-brand-ivory">
        <div className="container-luxe max-w-3xl">
          <div className="divide-y divide-brand-charcoal/10 border-y border-brand-charcoal/10">
            {FAQS.map((f, i) => (
              <Reveal key={f.q} delay={i * 40}>
                <button
                  onClick={() => setOpen(open === i ? -1 : i)}
                  className="w-full flex items-center justify-between gap-6 py-6 text-left group"
                  data-testid={`faq-item-${i}`}
                >
                  <h4 className={`font-serif text-xl md:text-2xl transition-colors ${open === i ? "text-brand-green" : "text-brand-charcoal group-hover:text-brand-green"}`}>{f.q}</h4>
                  <span className="w-8 h-8 border border-brand-charcoal/20 flex items-center justify-center text-brand-charcoal/70 shrink-0">
                    {open === i ? <Minus className="w-3.5 h-3.5" /> : <Plus className="w-3.5 h-3.5" />}
                  </span>
                </button>
                <div className={`overflow-hidden transition-all duration-500 ease-out ${open === i ? "max-h-96 pb-6" : "max-h-0"}`}>
                  <p className="text-brand-charcoal/70 text-[15px] leading-[1.85] max-w-2xl">{f.a}</p>
                </div>
              </Reveal>
            ))}
          </div>

          <div className="mt-16 text-center">
            <p className="text-brand-charcoal/60 mb-6">Have a question we haven't covered?</p>
            <Link to="/contact" className="luxe-btn-outline text-brand-green border-brand-green hover:bg-brand-green hover:text-brand-ivory inline-flex" data-testid="faq-contact-cta">
              Contact us <ArrowRight className="w-4 h-4" />
            </Link>
          </div>
        </div>
      </section>
    </>
  );
}
